import { Card, Col, Row, Section, Skeleton, Space } from 'ui';

type P = {
  card?: boolean;
};

const ContentSkeleton = () => (
  <Space orientation="vertical" size="large" style={{ display: 'flex' }}>
    {Array.from({ length: 3 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      <Row key={index}>
        <Col span={2}>
          <Skeleton.Avatar active size="large" />
        </Col>
        <Col flex="auto">
          <Skeleton active paragraph={{ rows: 3, style: { margin: 0 } }} title={{ style: { display: 'none' } }} />
        </Col>
      </Row>
    ))}
    <Row>
      <Col span={2}>
        <Skeleton.Avatar active size="large" />
      </Col>
      <Col flex="auto">
        <Skeleton.Input active block size="large" />
      </Col>
    </Row>
  </Space>
);

const CommentsSkeleton = ({ card }: P) =>
  card ? (
    <Card>
      <ContentSkeleton />
    </Card>
  ) : (
    <Section>
      <ContentSkeleton />
    </Section>
  );

export default CommentsSkeleton;
